import EyeLoading from "components/atoms/icons/animated/eye/EyeLoading";
import { useCallback, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import {
  useGetClientConfiguration,
  useGetClientModuleConfiguration,
} from "services/configuration";
import { IChildrenProp } from "types/components/components.interface";

const ConfigurationProvider = ({ children }: IChildrenProp) => {
  const configuration = useGetClientConfiguration();
  const clientConfiguration = useGetClientModuleConfiguration();

  const [isLoadingScreenVisible, setIsLoadingScreenVisible] = useState(true);

  const hideLoadingScreen = useCallback(() => {
    setTimeout(() => {
      setIsLoadingScreenVisible(false);
    }, 1000);
  }, []);

  useEffect(() => {
    if (
      configuration.data &&
      clientConfiguration.data &&
      isLoadingScreenVisible
    ) {
      hideLoadingScreen();
    }
  }, [configuration.data, clientConfiguration.data]);

  return (
    <>
      <Helmet>
        <link
          rel="icon"
          href={
            clientConfiguration.data?.currentLogoPath ??
            `${process.env.PUBLIC_URL}/icons/logo.svg`
          }
        />
        <link
          rel="apple-touch-icon"
          href={
            clientConfiguration.data?.currentLogoPath ??
            `${process.env.PUBLIC_URL}/icons/logo.svg`
          }
        />
      </Helmet>
      {children}
      <div
        className="absolute top-0 h-full w-full flex items-center justify-center z-50"
        style={{
          background: "#000",
          pointerEvents: isLoadingScreenVisible ? "all" : "none",
          opacity: isLoadingScreenVisible ? "1" : "0",
          transition: "0.3s ease-in-out",
        }}
      >
        <div
          style={{
            transform: isLoadingScreenVisible ? "scale(1)" : "scale(0)",
            transition: "0.3s ease-in-out",
          }}
        >
          <EyeLoading />
        </div>
      </div>
    </>
  );
};

export default ConfigurationProvider;
